<template>
  <div style=" background-color:#f3f1f1 ;  font-size:0.28rem  ">
    <div
      style=" background-image: url( ../../../../static/Activity/2018HuaTie/Index/MainTop.jpg );
        background-size: cover;  height: 3.2rem   "
    >
      <div style="color:black ; padding:0.35rem 0 0 0.35rem ">
        <!-- <div v-if=" NowUser==''" style=" " v-on:click="goLogout()"> 登录/注册 </div>
        <div v-else style=" " v-on:click="goLogout()"> {{ this.NowUser }} [注销]</div>-->
        <div v-if=" NowUser=='' && !openid  " style=" " v-on:click="goLogout()">登录/注册</div>
        <div v-else-if="openid" style=" ">临时用户bhsdgsdgwe423</div>
        <div v-else style=" " v-on:click="goLogout()">{{ this.NowUser }} [注销]</div>
      </div>
      <!-- {{ this.openid }} -->
    </div>

    <div style=" line-height:0.7rem ; height:0.7rem ; overflow:hidden ;  font-size:0.27rem">
      <div id="MidLine">
        <div style v-for=" item in ShowList" :key="item">
          <img src="../../../../static/Activity/2018HuaTie/Index/horn.png" style="width:0.35rem">
          {{item}}
        </div>
        <div style=" " v-if="ShowList.length == 0">
          <img src="../../../../static/Activity/2018HuaTie/Index/horn.png" style="width:0.35rem"> 恭喜用户138XXXX5647抽中￥200免房券
        </div>
      </div>
    </div>

    <!-- 抽奖的框 -->
    <div style="color:#333;  text-align:center ; overflow:hidden ; ">
      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 0 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box0.jpg" style="   ">
      </div>
      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 1 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box1.jpg" style="   ">
      </div>
      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 2 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box2.jpg" style="   ">
      </div>

      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 3 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box3.jpg" style="   ">
      </div>

      <!-- 
        <div class="CenterBox " style=" color:white;text-align:center;  border-radius: 24px; background-color:#e83428 " >
          <div style="padding-top:0.5rem ; margin:0.1rem;border-radius: 24px;box-shadow: 7px 8px 7px 0px rgba(129, 5, 5, 0.35); background-color:#ea5413 ;width:2.0rem; height:2rem">
            <div>立即抽奖</div>
            <div>(还有3次机会)</div>
          </div>
      </div>-->
      <div
        v-on:click="HuaTie2018ChouJiang()"
        style=" margin: 0 0 0 3.3%;float:left  "
        :class=" {'OutBlue': ChoosePic%9 == 4 } "
      >
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box4.png" style=" width:2.2rem ;  ">
        <div style="margin-top:-1.1rem ; color:white">(还有{{DrawTotal}}次机会)</div>
      </div>

      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 5 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box5.jpg" style="   ">
      </div>

      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 6 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box6.jpg" style="   ">
      </div>
      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 7 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box7.jpg" style="   ">
      </div>
      <div class="CenterBox" :class=" {'OutBlue': ChoosePic%9 == 8 } ">
        <img src="../../../../static/Activity/2018HuaTie/MidPic/Box8.jpg" style="   ">
      </div>
    </div>

    <div
      v-on:click="GoIndex()"
      style="margin:0.2rem 0 0.6rem 0;background-color:#ea5413; box-shadow:2px 2px 8px #aaa; width:50%;margin-left:25% ; "
      class="MainButtonBase"
    >
      <div style="text-shadow: 1px 1px 6px #7a2b09;">酒店预订</div>
    </div>

    <div
      style="color:black ; background-color:white; box-shadow:#e7d4d4 0px 0px 0.3rem ; margin:0 4% ; padding:0.3rem;"
    >
      <div>活动规则：</div>
      <div>1.每个会员每天有3次抽奖机会，奖项设置为200元免房券、20元储值金、5元现金券、5K币/20K币/100K币、10元/20元住房代金券、格林酒店集团会员适用。</div>
      <div>2.奖券适用于格林旗下格林东方、格美、格雅、格菲、格林豪泰、格盟、青皮树、贝壳8大品牌酒店。</div>
      <div>活动时间：</div>
      <div>2018年11月30日-2019年3月29日。</div>
    </div>

    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline"/>
    <div style="height: 1.7rem;width:100%"></div>

    <div id="bg_show" v-show="ShowPage != 0 " v-on:click="CleanShadow()">
      <!-- <img src="../../../../static/Activity/Tips/cancel.png" style=" width: 0.8rem ; top:10.5rem;left: 3.4rem; position:fixed " /> -->
    </div>

    <!-- 分享提示悬浮层 -->
    <div
      v-if="ShowPage == 1 "
      style=" position:fixed ; top: 12% ; width:100% ; z-index:1002 ; left:10%"
      v-on:click="CleanShadow()"
    >
      <img src="../../../../static/Activity/Tips/WXShare.png" style=" width: 80% ">
    </div>

    <!-- 抽奖结果 弹出奖品  -->
    <div v-if="ShowPage == 11 " class="ShadowTips" align="center">
      <div style>
        <img
          :src="'../../../../static/Activity/2018HuaTie/ShowPrize/弹窗-'+ ResultItem.PrizeName +'.png'"
          style="    width:80% "
        >
      </div>

      <div
        v-on:click="CleanShadow()"
        style=" position:relative ; width:1.1rem ; height:1.1rem ; margin-top:-1.1rem ;  "
      ></div>
      <div
        v-on:click="CleanShadow()"
        style=" position:relative ; width: 3.5rem; height: 0.8rem; margin-top: -2.8rem;  "
      ></div>
      <div
        v-on:click="GoDown()"
        style=" position:relative ; width: 1.6rem; height: 0.6rem; margin-top:-1.9rem; margin-left:2rem;  "
      ></div>

      <!-- <div  v-on:click="GetRealPrize()"  v-if="  ResultItem.PrizeName != '200元免房券' && ResultItem.PrizeType == '大奖' " style=" position:relative ; background-color:   ; width:3.1rem ; height: 0.9rem ; margin-top: -2.8rem ;  " >      </div> -->
    </div>
  </div>
</template>



<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../../api";

var wx = require("weixin-js-sdk");

export default {
  activated() {
    var params = new this.URLSearchParam();
    this.$http.post(api.HuaTie2018ShowList(), params.toParam()).then(res => {
      this.ShowBoxMethod(0);
      this.ShowList = res.Data;
      this.StartLun();
    });

    this.HuaTie2018CheckLoginNew();
    document.getElementById("bg_show").style.height =
      document.body.scrollHeight + "px";
  },
  mounted() {},
  data() {
    return {
      openid: "",
      NowUser: "",
      DrawTotal: 0,

      ShowList: [],

      // 弹出层 弹出内容
      toast: false,
      TellUser: "",
      // 弹出层 弹出内容  END

      // 滚动播放功能
      position: 0,

      ShowPage: 0,

      // 抽奖结果
      ResultItem: {},

      // 选中图片
      ChoosePic: -1,

      ResPrize: -2,

      IsChouJianging: false,

      SubmitInfo: { UserName: "", UserPhone: "", UserAddress: "", UserBB: "" }
    };
  },
  methods: {
    IsWX() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (isWeixin) {
        return true;
      } else {
        return false;
      }
    },

    GetRealPrize() {
      this.ShowPage = 12;
    },

    // 判断登录 + 已登录（X条最新邀请记录） 、 未登录（）   + 获取审批后评论
    HuaTie2018CheckLogin() {
      var params = new this.URLSearchParam();
      params.append("userId", this.$route.query.userId);
      params.append("sign", this.$route.query.sign);

      this.$http
        .post(api.HuaTie2018CheckLogin(), params.toParam())
        .then(res => {
          if (res.Result) {
            if (res.Data.Islogin) {
              // 用户名
              this.NowUser = res.Data.Message;
              this.DrawTotal = res.Data.DrawTotal;
            } else {
              this.TellUser = res.Data.Message;
              this.showToast();
            }
          } else {
            this.TellUser = res.Message;
            this.showToast();
          }
        });
    },

    // 判断登录 + 已登录（X条最新邀请记录） 、 未登录（）   + 获取审批后评论
    HuaTie2018CheckLoginNew() {
      this.ShowBoxMethod(-1);
      // 微信浏览器
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;

      if (!this.$route.query.code) {
        // 微信浏览器打开
        if (isWeixin) {
          // let baseurl = "https://wechattest.greentree.cn";
          // let WXappid = "wx330c5becf5a36a7f"; //appId   贝壳测试号

          let baseurl = "https://i.998.com";
          let WXappid = "wx384b5da598edc120"; //appId 格林服务号;

          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            WXappid +
            "&redirect_uri=" +
            window.location.href +
            "&response_type=code&scope=snsapi_base&state=" +
            "gxx" +
            "#wechat_redirect";
        } else {
          this.tmpLogin();
        }
      } else {
        this.tmpLogin();
      }
    },

    tmpLogin() {
      // 获取到code
      var params = new this.URLSearchParam();
      params.append("code", this.$route.query.code);
      this.$http.post(api.CodeToInfo(), params.toParam()).then(res => {
        this.ShowBoxMethod(0);
        if (res.Result) {
          if (res.Data.Islogin) {
            // 用户名
            this.openid = "";
            this.NowUser = res.Data.Message;
            this.DrawTotal = res.Data.DrawTotal;
          } else {
            if (res.Data.openid != null) {
              this.openid = res.Data.openid;
              this.DrawTotal = res.Data.DrawTotal;

              if (this.DrawTotal == 0) {
                this.ResultItem.PrizeName = "20元代金券";
                this.ShowBoxMethod(11);
              }
            }
          }
        } else {
          this.TellUser = res.Message;
          this.showToast();
        }
      });
      return;
    },

    // 购买抽奖次数窗口
    ShowBoxMethod(code) {
      this.ShowPage = code;
      document.getElementById("bg_show").style.height =
        document.body.scrollHeight + "px";
    },

    // 回到主界面
    CleanShadow() {
      if (this.openid) {
        this.goLogout();
        return;
      }
      this.ShowPage = 0;
    },

    // 抽奖。抽奖。抽奖。
    HuaTie2018ChouJiang() {
      var params = new this.URLSearchParam();

      if (this.NowUser == "") {
        if (this.openid) {
          params.append("openid", this.openid);
        } else {
          this.$http.post(api.LogOff()).then(res => {});
          this.$store.dispatch("clearUser");
          this.toastTimer = setTimeout(() => {
            this.$router.push({ path: "/user/login" });
          }, 200);
          return;
        }
      }

      if (this.DrawTotal == 0) {
        if (this.openid) {
          this.goLogout();
          return;
        }
        this.TellUser = "抽奖次数已用完~";
        this.showToast();

        this.GoBottom();
        return;
      }

      if (this.IsChouJianging == true) {
        this.TellUser = "正在获取奖品中~";
        this.showToast();
        return;
      }

      this.IsChouJianging = true;

      this.ChoosePic = -1;
      this.LoopPrize();

      if (this.DrawTotal != 0) this.DrawTotal = this.DrawTotal - 1;

      this.$http.post(api.HuaTie2018ChouJiang(), params.toParam()).then(res => {
        if (res.Result) {
          // 可抽奖次数
          this.DrawTotal = res.Data.DrawTotal;

          this.ResultItem = res.Data.Data;

          if (this.ResultItem.PrizeName == "200元免房券") this.ResPrize = 0;
          else if (this.ResultItem.PrizeName == "20元储值金") this.ResPrize = 1;
          else if (this.ResultItem.PrizeName == "5元现金券") this.ResPrize = 2;
          else if (this.ResultItem.PrizeName == "100K币") this.ResPrize = 3;
          else if (this.ResultItem.PrizeName == "10元代金券") this.ResPrize = 5;
          else if (this.ResultItem.PrizeName == "5K币") this.ResPrize = 6;
          else if (this.ResultItem.PrizeName == "20K币") this.ResPrize = 7;
          else if (this.ResultItem.PrizeName == "20元代金券") this.ResPrize = 8;
        } else {
          this.IsChouJianging = false;

          this.ResPrize = -3;

          if (this.DrawTotal != 0) this.DrawTotal = this.DrawTotal + 1;

          if (res.Message == "每天只能抽奖30次") {
            this.ShowBoxMethod(4);
          } else if (res.Message == "抽奖次数已用完") {
            this.TellUser = "今天抽奖次数已用完";
            this.showToast();

            this.GoBottom();
          } else {
            this.TellUser = res.Message;
            this.showToast();
          }
          // 结果出错 -2  默认 -1  正常结果 0-8
        }
      });
    },

    // 抽奖的循环高亮跳
    LoopPrize() {
      if (this.ResPrize == -3) {
        this.ResPrize = -2;
        this.ChoosePic = -1;
        return;
      }

      this.ChoosePic += 1;
      if (this.ChoosePic % 9 == 4) this.ChoosePic += 1;

      if (this.ResPrize == this.ChoosePic % 9) {
        this.ResPrize = -2;

        // 显示抽奖结果
        this.ShowBoxMethod(11);
        this.IsChouJianging = false;

        return;
      }
      var s = setTimeout(this.LoopPrize, 120);
    },

    GoBottom() {
      var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      var maxScroll =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      window.scrollTo(0, currentScroll + 4);

      if (clientHeight + currentScroll >= maxScroll - 1) {
        // this.TellUser = '您可以完成下方任务赢取抽奖机会~';
        // this.showToast();
        return;
      }

      var GoBottom = setTimeout(this.GoBottom, 15);
    },

    // 跳转 登出
    goLogout() {
      this.NowUser = "";
      // 接口登出
      this.$http.post(api.LogOff()).then(res => {
        if (res.Result) {
          this.$store.commit("CLEARUSER");
          this.$router.push({ path: "/user/Login" });
        } else {
          this.TellUser = res.Message;
          this.showToast();
        }
      });
    },

    StartLun() {
      setTimeout(this.LunWords, 2000);
    },

    LunWords() {
      this.position += 1;

      document.getElementById("MidLine").style.marginTop =
        -0.01 * this.position + "rem";

      if (this.position % 70 == 0) {
        //到达300、600、900的时候，轮播图片将停止一下
        setTimeout(this.LunWords, 2000);
      } else if (this.position >= 690) {
        this.position = 0;
        document.getElementById("MidLine").style.marginTop = "0rem";
        var s = setTimeout(this.LunWords, 2500);
      } else {
        var s = setTimeout(this.LunWords, 25);
      }
    },

    // GoHelp() {
    //   this.$router.push({ path: "/Activity/AutumnHelp" });
    // },

    GoIndex() {
      this.$router.push({ path: "/home/index?sourcecode=greentreehtggH5" });
    },

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 1700);
      if (this.TellUser == "请先登录") {
        // this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch("clearUser");
        this.NowUser = "";
        // this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 2000)
      }
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    // 弹出层  end

    GoDown() {
      window.location.href =
        "https://i.998.com/applink.htm?sourcecode=jthd910ewmXZapp";
    }
  }
};
</script>




<style lang="less" scoped>
.OutBlue {
  border: 0.1rem solid #fc5943;
}

// 抽奖九宫格
.CenterBox {
  border-radius: 4px;
  font-weight: bold;
  float: left;
  width: 30%;
  text-align: center;
  background-color: white;
  width: 2.22rem;
  height: 2.2rem;
  margin: 0 0 3% 3%;

  img {
    // margin-top:0.1rem;
    width: 2rem;
  }
}

// 邀请，预定，支付，首页副口
.WhiteBox {
  background-color: white;
  margin-top: 0.3rem;
  height: 1.2rem;
  img {
    float: left;
    width: 0.65rem;
    margin: 0.275rem 0.2rem 0 0.3rem;
  }
  .InnerBox {
    float: left;
    line-height: 0.35rem;
    margin-top: 0.25rem;
    font-size: 0.24rem;
  }
  .RightBotton {
    float: right;
    border-radius: 30px;
    border: 2px solid #fc5943;
    color: #fc5943;
    height: 0.6rem;
    line-height: 0.55rem;
    // width: 1.1rem;
    padding: 0rem 0.25rem;
    margin: 0.3rem 0.3rem 0 0;
  }
}

.MainButtonBase {
  border-radius: 4px;
  background-color: #fc5943;
  color: white;
  line-height: 0.9rem;
  width: 47%;
  font-size: 0.34rem;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.04rem;
}

// 展示中奖信息
#MidLine {
  div {
    height: 0.7rem;
    line-height: 0.7rem;
    color: #333;
    text-align: center;
  }
}

.SecondWhite {
  border-radius: 0 0 3px 3px;
  text-align: center;
  background-color: white;
  min-height: 5rem;
  width: 80%;

  .LastGrey {
    color: #939599;
    font-size: 0.26rem;
    padding-bottom: 0.9rem;
  }
}

.ShadowTips {
  position: fixed;
  top: 20%;
  width: 100%;
  z-index: 1002;
  max-width: 7.5rem;
}

.InputItem {
  border-bottom: 1px solid #ccc;
  padding: 0.2rem 0.05rem;
  overflow: hidden;
  input {
    border: 0;
    outline: 0;
    // border-bottom: 0.02rem solid #ccc;
    // padding-bottom:0.1rem;

    float: left;
  }

  input::-webkit-input-placeholder {
    color: #aab2bd;
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?bcb29fd2